
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparTShape as ObiBuoySparTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-t-shape.js';
 
 
 

 
 export const ObiBuoySparTShape = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-t-shape',
   elementClass: ObiBuoySparTShapeElement,
   events: {
     
   }
  });
 
 